import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import Malaria from "../components/sections/Malaria";
import { WomenEmpowerment, Environment } from "../components/sections/SplitSections";
import ImpactGallery from "../components/sections/ImpactGallery";
import { SpecialCta } from "../components/sections/CtaSections";

export default function Campaigns() {
  return (
    <main>
      <Seo
        title="हमारे अभियान — मलेरिया जागरूकता, वृक्षारोपण, स्वच्छता"
        description="Anansha Welfare Society के जागरूकता अभियान — मलेरिया से बचाव, वृक्षारोपण, स्वास्थ्य एवं स्वच्छता जागरूकता, महिला सशक्तिकरण — वाराणसी, उत्तर प्रदेश।"
        path="/campaigns"
        breadcrumb={["अभियान"]}
      />
      <PageHero
        overline={{ hi: "अभियान", en: "Campaigns" }}
        title={{ hi: "हमारे अभियान", en: "Our Campaigns" }}
        description={{
          hi: "मलेरिया जागरूकता, वृक्षारोपण, स्वास्थ्य एवं स्वच्छता — समुदाय के बीच चलाए जा रहे जागरूकता अभियान।",
          en: "Malaria awareness, tree plantation, health and hygiene — awareness campaigns run within communities.",
        }}
        testid="campaigns-page-heading"
      />
      <Malaria />
      <WomenEmpowerment />
      <Environment />
      <ImpactGallery limit={6} showMore={false} />
      <SpecialCta />
    </main>
  );
}
